import Vue from "vue";
import axios from "axios";
import commonService from "./common";

// let baseURL = `${process.env.VUE_APP_CONFIG_RF_BASEURL}`;

let config = {
    method: "get",
    url: '',
    headers: {
        "x-api-key": `${process.env.VUE_APP_CONFIG_RF_APIKEY}`,
    },
    // data: data,
};

const axiosClient = axios.create(config);

const rfDashboardService = {

    getRfQuery(data) {
        let { index, from_dt, to_dt, from_msisdn, to_msisdn, cause_code, result_type } = data;
        let param = `GetRfQuery&index=${index}&from_dt=${from_dt}&to_dt=${to_dt}&from_msisdn=${from_msisdn}&to_msisdn=${to_msisdn}&cause_code=${cause_code}&result_type=${result_type}`;
        config.url = `${process.env.VUE_APP_CONFIG_BASEURL}?method=${param}`;
        // return commonService.commonAPI(param)
        //   .then(response => response.data.message)
        //   .catch(error => console.error(error))
        return new Promise((resolve, reject) => {
            axiosClient
                .request(config)
                .then((response) => {
                    // console.log(response.data.message);
                    if (response.data.message.hasOwnProperty("hits")) {
                        resolve(response.data.message);
                    } else {
                        reject(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
	},
};

export default rfDashboardService;
